import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.index-of";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  margin: auto;\n  margin-top: 0.75rem;\n\n  grid-auto-columns: 1fr;\n  grid-auto-rows: 1fr;\n  // grid-template-columns: repeat(3; 1fr);\n\n  .progressbar {\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    align-items: stretch;\n\n    .nav {\n      display: table;\n      table-layout: fixed;\n      text-align: center;\n      line-height: normal;\n      font-style: normal;\n      font-weight: bold;\n      font-family: ", ";\n      text-transform: uppercase;\n      color: '#58585B';\n\n      a {\n        display: table-cell;\n        border-width: ", ";\n        border-color: black;\n        border-style: solid;\n        border-left-width: 0;\n        padding: 0.85em 0.5em;\n        color: black;\n        background: ", ";\n        width: 2%;\n        font-size: 0.85em;\n        vertical-align: middle;\n\n        &:last-child {\n          grid-column-start: 2;\n        }\n\n        &:first-of-type {\n          border-left-width: ", ";\n        }\n\n        &.completed,\n        &.completed.current {\n          cursor: pointer;\n          color: ", ";\n          background: ", ";\n        }\n\n        &.uncompleted {\n          background: ", ";\n        }\n\n        &.completed.focused.current {\n          color: ", ";\n          cursor: pointer;\n          background: #f2f2f2;\n        }\n\n        &.completed.focused,\n        &.completed:hover {\n          color: ", ";\n          cursor: pointer;\n          background: #b0d9ff;\n        }\n\n        &.done,\n        &.done:hover,\n        &.completed.focused.done.current {\n          color: ", ";\n          cursor: default;\n          background: #f2f2f2;\n        }\n\n        &.completed.current {\n          color: ", ";\n          background: #f2f2f2;\n        }\n      }\n    }\n\n    .progress-text {\n      justify-content: flex-end;\n      font-style: italic;\n      font-size: 1rem;\n      margin-top: 0.5rem;\n\n      .mobile {\n        display: none;\n      }\n    }\n  }\n\n  @media screen and (max-width: 540px) {\n    max-width: 25.875em;\n\n    .progressbar {\n      .nav {\n        a {\n          overflow: hidden;\n          min-width: 10px;\n          padding: 0.5em 0;\n          text-indent: -500px;\n          line-height: 0;\n        }\n      }\n\n      .progress-text {\n        .mobile {\n          display: inline-block;\n        }\n      }\n    }\n  }\n\n  @media (min-width: 541px) and (max-width: 1024px) {\n    .progressbar {\n      .nav {\n        a {\n          padding: 0.85em 0;\n          font-size: 0.55rem;\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useState } from 'react';
import { BLACK, WHITE, OPTIMISTIC_BLUE_DARK, GRAY_200, SANS } from '../utilities/constants';
export default function ProgressNav(props) {
  var steps = props.steps,
      currentStep = props.currentStep,
      showStepName = props.showStepName,
      offset = props.offset,
      completed = props.completed,
      clickHandler = props.clickHandler,
      blockStepBackAfterLastNav = props.blockStepBackAfterLastNav,
      disableOnEnd = props.disableOnEnd,
      totalSteps = props.totalSteps;

  var _useState = useState(currentStep),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocus = _useState2[1];

  var stepElem = function stepElem(step, key, index) {
    var formDone = completed && completed.length === totalSteps;
    var cssObj = {
      completedCss: index && index.indexOf(key) > -1 ? "completed" : "uncompleted",
      focusedCss: currentStep === key ? "focused" : "",
      doneCss: formDone ? "done" : "",
      disableCss: disableOnEnd && disableOnEnd === true ? "disabled" : "",
      currentCss: key === index[index.length - 1] ? "current" : ""
    }; // Filter out object key/value with empty strings eq. ``

    Object.keys(cssObj).forEach(function (k) {
      return cssObj[k] == '' && delete cssObj[k];
    }); // Output obj values as string of classNames

    var cssArrToString = Object.keys(cssObj).map(function (obj) {
      return cssObj[obj];
    }).toString().replace(/,/g, ' ');
    var set_Focus = index && index.indexOf(key) > -1 && !formDone ? function () {
      return setFocus(key);
    } : function () {};
    var evalCurrStep = steps.length - 1;
    var blockStepBack = typeof blockStepBackAfterLastNav === 'undefined' || blockStepBackAfterLastNav && blockStepBackAfterLastNav === true;
    var on_Click = index && index.indexOf(key) > -1 && currentStep < evalCurrStep && blockStepBack ? function () {
      return clickHandler(key);
    } : function (e) {
      return e.preventDefault();
    };
    var linkParam = {
      key: key,
      title: "".concat(step),
      onClick: on_Click,
      'aria-label': "".concat(step),
      className: "".concat(cssArrToString)
    };

    if (formDone) {
      linkParam['onTouchMove'] = set_Focus;
      linkParam['onMouseEnter'] = set_Focus;
    }

    var $link = jsx("a", Object.assign({}, linkParam), step, jsx("span", {
      className: "arrow"
    }));
    return $link;
  };

  var currStepCount = offset && typeof offset === 'number' ? currentStep + offset : currentStep;

  var progressText = function progressText() {
    return jsx("span", null, "Step ".concat(currStepCount + 1, " of ").concat(steps.length));
  };

  var mobileText = function mobileText() {
    var showStepNameCss = showStepName && showStepName === true ? "" : "mobile";
    return jsx("span", {
      className: "".concat(showStepNameCss)
    }, ": ", " ", steps[focused]);
  };

  return jsx("div", {
    css: PROGRESSBAR_STYLE
  }, jsx("div", {
    className: "progressbar"
  }, jsx("div", {
    className: "nav"
  }, steps && steps.map(function (step, index) {
    return stepElem(step, index, completed);
  })), jsx("div", {
    className: "progress-text"
  }, progressText(), mobileText())));
}
var BORDER_WIDTH = '1px';
var PROGRESSBAR_STYLE = css(_templateObject(), SANS, BORDER_WIDTH, WHITE, BORDER_WIDTH, WHITE, OPTIMISTIC_BLUE_DARK, GRAY_200, BLACK, BLACK, BLACK, BLACK);